import graphql__3c2edb867c7072f1fe78 from "./__generated__/MapUsersPointsManagerQuery.graphql.js";import { graphql } from "react-relay";

import AppQueryRenderer from "../../AppQueryRenderer";
import { useMapContext } from "../MapContext";
import MapUsersPoints, { USERS_MAP_USERS_MARKERS_COUNT } from "./MapUsersPoints";

const MapUsersPointsManager = () => {
  const { mapSlug: usersMapSlug } = useMapContext();
  const usersMapUsersCount = USERS_MAP_USERS_MARKERS_COUNT;

  return (
    <AppQueryRenderer
      key={usersMapSlug}
      query={MapUsersPointsManagerQuery}
      variables={{ usersMapSlug, usersMapUsersCount }}
      component={MapUsersPoints}
    />
  );
};

export default MapUsersPointsManager;

const MapUsersPointsManagerQuery = graphql__3c2edb867c7072f1fe78;
